import React from "react";

function RelationshipResult({ personA, personB, relationship, error }) {
  if (error) {
    // Split on double newline so multi-part messages each get their own paragraph
    const parts = error.split("\n\n");
    return (
      <div className="rounded-[16px] shadow-lg p-[24px] border border-red-300 dark:border-red-800 bg-red-50 dark:bg-red-900/30 text-center flex flex-col gap-y-[12px]">
        <p className="text-red-600 dark:text-red-400">{parts[0]}</p>
        {parts[1] && (
          <p className="text-dupontGray dark:text-darkTextSecondary text-[14px] italic">{parts[1]}</p>
        )}
      </div>
    );
  }

  if (!relationship) return null;

  const isSelf = relationship === "self";
  const displayLabel = isSelf ? "Same Person" : relationship;

  return (
    <div className="rounded-[16px] shadow-lg p-[24px] border border-dupontGold bg-white dark:bg-darkCard text-center">
      <p className="text-dupontGray dark:text-darkTextSecondary text-[14px]">Relationship</p>
      <p className="text-[28px] font-serif font-bold text-dupontBlue dark:text-darkText mt-[4px]">
        {displayLabel}
      </p>
      {!isSelf && personA && personB && (
        <p className="text-[16px] text-dupontGray dark:text-darkTextSecondary mt-[8px]">
          {personA.label} is the {displayLabel.toLowerCase()} of{" "}
          {personB.label}
        </p>
      )}
    </div>
  );
}

export default RelationshipResult;
